import { render, staticRenderFns } from "./LabelValueInfo.vue?vue&type=template&id=17be033a&scoped=true"
import script from "./LabelValueInfo.vue?vue&type=script&lang=js"
export * from "./LabelValueInfo.vue?vue&type=script&lang=js"
import style0 from "./LabelValueInfo.vue?vue&type=style&index=0&id=17be033a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be033a",
  null
  
)

export default component.exports